import React from 'react';
// import WebglBackground from 'react-scale/components/ui/webgl/glow-gradient';
import CTA from 'react-scale/components/ui/cta';
import cx from 'classnames';

const hero = ({ title, subtitle, cta, img, theme }) => (
  <div>
    <div className="absolute z-0 hidden max-w-full overflow-hidden lg:block">
      {/* <WebglBackground
        mode="1"
        width="100%"
        height="936px"
        color1="#484589"
        color2="#484589"
        color3="#000"
        color4="#484589"
      /> */}
    </div>
    <div className="relative">
      <div
        className={cx(
          'container ',
          { 'text-black': theme === 'light' },
          { 'text-white': theme === 'dark' }
        )}
      >
        <div className="flex flex-col justify-center align-middle md:flex-row">
          <div className="my-14 md:my-28 md:max-w-md lg:max-w-2xl">
            <h1 className="font-light font-aeonik">{title}</h1>
            <p className="mt-6 text-base md:text-2xl font-aeonik lg:pr-40">{subtitle}</p>
            <div className="mt-8 ">
              <CTA cta={cta} theme={theme} />
            </div>
          </div>
          <div className={cx(' relative flex  items-center')}>{img}</div>
        </div>
      </div>
    </div>
  </div>
);

hero.defaultProps = {
  title: 'Rapid Labels',
  subtitle:
    'Rapid Labels is a cloud-based, scalable, and secure label printing platform that enables you to print labels in seconds.',
  cta: {
    buttons: [
      { text: 'Get Started', href: '/signup', variant: 'primary' },
      { text: 'Learn More', href: '/sales', variant: 'secondary' }
    ]
  },
  theme: 'dark'
};

export default hero;
